import { Icon } from "src/components/layout/nav/icons/lifecycle-studio";
import { UseSectionHook } from "./types";
import { NavSection } from "src/components/layout/nav/nav-section";
import { ActiveSectionProps } from "src/components/layout/nav/utils";
import { useLifecycleStudioEnabled } from "src/hooks/use-lifecycle-studio-enabled";
import { useResourcePermission } from "src/components/permission/use-resource-permission";

export const useLifecycleStudioSection: UseSectionHook = () => {
  const isLifecycleStudioEnabled = useLifecycleStudioEnabled();

  return {
    title: "Lifecycle Studio",
    isEnabled: isLifecycleStudioEnabled,
    links: [
      {
        isSub: true,
        href: "/lifecycle-studio/projects",
        label: "Campaigns",
      },
      {
        isSub: true,
        href: "/lifecycle-studio/messages",
        label: "Messages",
      },
      {
        isSub: true,
        href: "/lifecycle-studio/templates",
        label: "Templates",
      },
      {
        isSub: true,
        href: "/lifecycle-studio/images",
        label: "Images",
      },
    ],
  };
};

export const LifecycleStudio = (props: ActiveSectionProps) => {
  const section = useLifecycleStudioSection();
  const { isPermitted: canViewAgents } = useResourcePermission({
    v2: { resource: "workspace", grant: "can_view_agents" },
  });

  if (!canViewAgents) {
    return null;
  }

  return <NavSection icon={Icon} {...section} {...props} />;
};
